<template>
	<div class="announcement-detail">
		<div
			class="scheduled-date-header"
			v-if="announcement && announcement.isScheduled"
		>
			<div class="scheduled-date-container content-row clickable">
				<div
					class="scheduled-date-label"
					v-t="'announcements_scheduled_title'"
				/>
				<div
					class="scheduled-date-info"
					v-text="$m.utc(announcement.scheduled).local().format('LLL')"
				/>
			</div>
			<div
				class="edit-link"
				@click="showEditModal = true"
				v-t="'common_button_edit'"
			/>
		</div>

		<div class="empty-state" v-if="!announcement">
			<BullhornIcon type="regular" halo />
			{{ $t('announcements_click_hint') }}
		</div>

		<AnnouncementView
			v-if="announcement"
			:announcement="announcement"
			showActions
		/>

		<AnnouncementComposer
			v-if="showEditModal"
			:editId="announcement.id"
			@close="showEditModal = false"
		/>
	</div>
</template>

<script>
import AnnouncementView from './AnnouncementView'
import AnnouncementComposer from './AnnouncementComposer'
import { getAnnouncementWithSender } from '@/store/announcements'
import { BullhornIcon } from '@/icons'

export default {
	components: {
		AnnouncementView,
		AnnouncementComposer,
		BullhornIcon,
	},

	props: { announcementId: [Number, String] },

	data() {
		return {
			announcement: getAnnouncementWithSender(this.announcementId),
			showEditModal: false,
		}
	},

	watch: {
		announcementId(id) {
			this.announcement = getAnnouncementWithSender(id)
		},
	},

	mounted() {
		EventBus.$emit('hamburgerDisabled', true)

		this.$onEventBus('announcement-update', () => {
			this.announcement = getAnnouncementWithSender(this.announcementId)
		})
	},

	beforeUnmount() {
		EventBus.$emit('hamburgerDisabled', false)
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.announcement-detail {
	position: relative;
	grid-area: details;
	width: 100%;
	height: 100%;
	padding: 16px 24px;
	display: flex;
	flex-direction: column;
	max-width: 100%;
	overflow: hidden;
	max-height: 100%;
	border-left: 1px solid var(--neutral-40040);

	.scheduled-date-header {
		@include flex-spread;
		height: 52px;
		flex-shrink: 0;
		margin: 0 16px;
		border-bottom: 1px solid var(--neutral-200);
		.scheduled-date-container {
			@include flex(16px);
			.scheduled-date-label {
				@include fontFamily(900);
			}
			.scheduled-date-info {
				@include fontFamily(900);
				padding: 4px 8px;
				border-radius: 6px;
				color: var(--blue-300);
				background: var(--blue-100);
				font-size: 14px;
			}
		}
		.edit-link {
			@include fontFamily(900);
			font-size: 15px;
			cursor: pointer;
			color: var(--blue-300);
		}
	}

	:deep(.announcement-view) {
		height: 100%;
		&.scheduled {
			height: calc(100% - 54px);
		}
		.target-label {
			@include fontFamily(900);
		}
		.announcement-text {
			flex-grow: unset;
		}
	}

	.empty-state {
		@include absolute-cover;
		@include flex-column-center;
		justify-content: center;
		color: var(--neutral-300);
		.pronto-icon {
			font-size: 50px;
			color: var(--neutral-300);
			margin-bottom: 16px;
		}
	}
}
</style>
<style lang="scss" scoped>
@import 'src/sass/variables';

@include overrideScheme('dark') {
	.announcements-wrapper {
		.announcement-detail {
			background: var(--neutral-0);

			.empty-state {
				color: var(--neutral-400);
				.pronto-icon {
					color: var(--neutral-400);
				}
			}
		}
	}
}

@include overrideContrast {
	.announcement-detail {
		.scheduled-date-info {
			color: white !important;
		}
	}
}
</style>
